import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/sign-in.jpg'
import _imports_1 from '@/assets/images/logos/sidebarlogo.png'


const _hoisted_1 = { class: "bg-white dark:bg-[#0a0e19] py-[60px] md:py-[80px] lg:py-[135px]" }
const _hoisted_2 = { class: "mx-auto px-[12.5px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1255px]" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-[25px] items-center" }
const _hoisted_4 = { class: "xl:ltr:pl-[90px] xl:rtl:pr-[90px] 2xl:ltr:pl-[120px] 2xl:rtl:pr-[120px] order-1 lg:order-2" }
const _hoisted_5 = { class: "flex items-center mb-[20px]" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "font-semibold text-black dark:text-white block" }
const _hoisted_8 = {
  class: "mb-[15px] relative",
  id: "passwordHideShow"
}
const _hoisted_9 = ["type"]
const _hoisted_10 = {
  key: 0,
  class: "text-red-500 text-sm mb-3"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "flex items-center justify-center gap-[5px]" }
const _hoisted_13 = {
  key: 0,
  class: "material-symbols-outlined"
}
const _hoisted_14 = {
  key: 1,
  class: "material-symbols-outlined"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "xl:ltr:-mr-[25px] xl:rtl:-ml-[25px] 2xl:ltr:-mr-[45px] 2xl:rtl:-ml-[45px] rounded-[25px] order-2 lg:order-1" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "lock-screen-image",
            class: "rounded-[25px]"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("img", {
            src: _imports_1,
            alt: "logo",
            class: "h-10"
          }, null, -1)),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "my-[17px] md:my-[25px]" }, [
            _createElementVNode("h1", { class: "font-semibold text-[22px] md:text-xl lg:text-2xl mb-[5px] md:mb-[10px]" }, " Welcome back to Trezo! "),
            _createElementVNode("p", { class: "font-medium leading-[1.5] lg:text-md text-[#445164] dark:text-gray-400" }, " Enter your password to access the app again. ")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.userProfilePicture,
              alt: "user-image",
              class: "rounded-full w-[50px] border-[2px] ltr:mr-[13px] rtl:ml-[13px] border-primary-200"
            }, null, 8, _hoisted_6),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userFullName), 1)
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleUnlock && _ctx.handleUnlock(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "mb-[10px] md:mb-[12px] text-black dark:text-white font-medium block" }, " Password ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                type: _ctx.passwordVisible ? 'text' : 'password',
                class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
                id: "password",
                placeholder: "Type password",
                required: ""
              }, null, 8, _hoisted_9), [
                [_vModelDynamic, _ctx.password]
              ]),
              _createElementVNode("button", {
                class: "absolute text-lg ltr:right-[20px] rtl:left-[20px] bottom-[12px] transition-all hover:text-primary-500",
                id: "toggleButton",
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.passwordVisible ? 'ri-eye-line' : 'ri-eye-off-line')
                }, null, 2)
              ])
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "submit",
              class: "md:text-md block w-full text-center transition-all rounded-md font-medium mt-[20px] py-[12px] px-[25px] text-white bg-primary-500 hover:bg-primary-400",
              disabled: _ctx.loading
            }, [
              _createElementVNode("span", _hoisted_12, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_13, " progress_activity "))
                  : (_openBlock(), _createElementBlock("i", _hoisted_14, " autorenew ")),
                _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Unlocking...' : 'Sign In'), 1)
              ])
            ], 8, _hoisted_11)
          ], 32)
        ])
      ])
    ])
  ]))
}